module.exports = __webpack_public_path__ + "img/progressbar.3990e106.gif";